import NotificationBar from './NotificationBar'

export default NotificationBar
